// 去掉resize的偏移
export function clearResizePosition(cube: CubeNode): void {
    cube.jView.find('.J_ShelvesBox').css({
        top: '',
        left: ''
    });
}
